// extracted by mini-css-extract-plugin
export var footer = "_nb-5";
export var fulfillmentInput = "_nb-0";
export var shipDateInput = "_nb-1";
export var shipmentModal = "_nb-2";
export var shipmentModalContent = "_nb-3";
export var tableContainer = "_nb-4";